import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, Validators} from "@angular/forms";
import {Observable} from "rxjs";
import {CounselingInductionService} from "../../counseling-induction.service";
import {ActivatedRoute} from "@angular/router";
import {EmployeeService} from "../../../../../../services/employee.service";

@Component({
  selector: 'app-add-row-pop-up',
  templateUrl: './add-row-pop-up.component.html',
  styleUrls: ['./add-row-pop-up.component.scss']
})
export class AddRowPopUpComponent implements OnInit ,AfterViewInit {
  counsellors$: Observable<any[]>;
  @ViewChild('topicField') topicField!: any;
  @ViewChild('dateField') dateField: any;
  @ViewChild('subTopicField') subTopicField: any;
  @ViewChild('descriptionField') descriptionField: any;
  @ViewChild('feedbackField') feedbackField: any;
  @ViewChild('inductorByField') inductorByField: any;

  dialogTitle = 'Add New Row';
  isEditMode = false;
  addRowForm = this.fb.group({
    topic: ['', Validators.required],
    inductorBy: [''],
    date: [''],
    subTopic: [''],
    description: [''],
    feedback: [''],
    orderNo: [],
    conductedBy: ['']
  });
  constructor(
    private fb: FormBuilder,
    private inductionService: CounselingInductionService,
    private route: ActivatedRoute,
    private dialog: MatDialogRef<AddRowPopUpComponent>,
    private readonly mEmployeeService: EmployeeService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data)
    this.counsellors$ = this.mEmployeeService.getCounsellersAndKavita();
  }

  ngOnInit(): void {
    // If data exists → Edit mode
    if (this.data) {
      this.isEditMode = true;
      this.addRowForm.patchValue({
        ...this.data,
        date: this.data.date ? new Date(this.data.date) : null
      });
    }
  }
  private fieldMap: { [key: string]: any } = {};

  ngAfterViewInit() {
    this.fieldMap = {
      topic: this.topicField,
      inductorBy: this.inductorByField,
      date: this.dateField,
      subTopic: this.subTopicField,
      description: this.descriptionField,
      feedback: this.feedbackField,
    };

    setTimeout(() => {
      if (this.data?.focusField) {
        const target = this.fieldMap[this.data.focusField];

        if (target) {
          if (target.focus && typeof target.focus === 'function') {
            target.focus();
          }
          else if (target.nativeElement) {
            target.nativeElement.focus();
          }
        }
      }
    }, 200);
  }


  submitRow() {
    if (this.addRowForm.invalid) return;
    const rowData = this.addRowForm.value;
    this.dialog.close(rowData);   // <-- RETURNS DATA TO PARENT
  }

}
